import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {EmpresasDetailParams} from '../../../../../chacra-core';

export interface EmpresasShowDialogData {
  empresa: EmpresasDetailParams;
}

@Component({
  selector: 'app-empresas-show-dialog',
  templateUrl: './empresas-show-dialog.component.html',
  styleUrls: ['./empresas-show-dialog.component.scss']
})
export class EmpresasShowDialogComponent {
  title = 'Datos de Empresa';
  aceptText = 'Aceptar';

  constructor(
    public dialogRef: MatDialogRef<EmpresasShowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EmpresasShowDialogData
  ) {
  }

  onAcept() {
    this.dialogRef.close(this.data);
  }
}
